import { set, keyBy } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { paginationSuccessHandler } from '../../../../../helpers/reducerPaginationHandler';
import {
  fetchInventoryActionOptions,
  fetchInventoryAuditLogsForItem
} from '../../../sagas/routines';
import {
  clearInventoryItemAuditLogs,
  inventoryItemAuditLogsOnChangePage
} from '../../../actions/components/view-item';
import {
  paginationState,
  resetPaginationState
} from '../../../../../helpers/pagination';

const initialState = {
  actionOptions: [],
  auditLogs: {},
  auditLogsPagination: paginationState(),
  fetchingActionOptions: false,
  fetchedActionOptions: false,
  fetchingAuditLogs: false,
  fetchedAuditLogs: false,
  fetchingAuditLogsError: false
};

const fetchActionOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetchingActionOptions: true,
    fetchedActionOptions: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('actionOptions', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetchingActionOptions: false,
    fetchedActionOptions: true
  })
});

const fetchInventoryItemAuditLogsHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetchingAuditLogs: true,
    fetchedAuditLogs: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    auditLogs: {
      ...state.auditLogs,
      ...keyBy('id', response.items)
    },
    auditLogsPagination: paginationSuccessHandler(
      state.auditLogsPagination,
      response
    )
  }),
  [routine.FAILURE]: (state, { error }) =>
    set('fetchingAuditLogsError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetchingAuditLogs: false,
    fetchedAuditLogs: true
  })
});

const clearInventoryItemAuditLogsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    auditLogs: {},
    auditLogsPagination: resetPaginationState(state.auditLogsPagination),
    fetchedAuditLogs: false
  })
});

const inventoryItemAuditLogsOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('auditLogsPagination.currentPage', page, state)
});

export default createReducer(initialState, {
  ...fetchActionOptionsHandler(fetchInventoryActionOptions),
  ...fetchInventoryItemAuditLogsHandler(fetchInventoryAuditLogsForItem),
  ...clearInventoryItemAuditLogsHandler(clearInventoryItemAuditLogs),
  ...inventoryItemAuditLogsOnChangePageHandler(
    inventoryItemAuditLogsOnChangePage
  )
});
